import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-string-list-input',
    templateUrl: './string-list-input.component.html',
    styleUrls: [
        './string-list-input.component.scss'
    ]
})

export class StringListInputComponent implements OnInit, OnChanges {
    @Input() name: string = "";
    @Input() label: string = "";
    @Input() selectionTitle: string = "";
    @Input() form: FormGroup = null;
    @Input() predefinedStringList: string[] = [];
    @Output() changeListEvt: EventEmitter<string[]> = new EventEmitter();

    stringList: string[] = [];

    constructor() { }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.predefinedStringList){
            this.stringList = changes.predefinedStringList.currentValue;
            console.log("new string list: "); console.dir(this.stringList);
        }
    }

    ngOnInit() { 
        this.stringList = this.predefinedStringList;
    }

    addString(){
        this.stringList.push(
            this.form.controls[this.name].value
        );
        this.changeListEvt.emit(this.stringList);
    }

    deleteString(str){
        const index = this.stringList.indexOf(str);
        this.stringList.splice(index, 1);
        this.changeListEvt.emit(this.stringList);
    }
}